import React from 'react';

const JS_Navigator = () => {
  return (
    <div >
      <h1>JS_Navigator</h1>
      <p>Placeholder component for: "JS Navigator"</p>
    </div>
  );
};

export default JS_Navigator;
